import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ProjectMonitorRecordWidgets from '../../../widgets/projectMonitorRecord/ProjectMonitorRecordWidgets'

export default function ProjectMonitorRecord() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const projectCode = sessionStorage.getItem('projectCode')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      // const response = await getManageBankAccount(projectCode)
      // setSchema(response.model)
      setSchema(mockSchema)
      console.log('schema', schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProjectDep6>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProjectDep6>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isSubProjectDep6>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi />

        <ProjectMonitorRecordWidgets schema={schema.model} />

        <br />
      </SidebarProposal>
    </div>
  )
}

const mockSchema = {
  affectedRows: 0,
  message: null,
  didError: false,
  errorMessage: null,
  model: {
    form: {
      header: null,
      formInput: {
        header: null,
        dateFollow: {
          name: 'dateFollow',
          label: 'วันที่ลงติดตาม',
          value: 0,
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณากรอกวันที่ลงติดตาม',
            },
          ],
        },
        followTimes: {
          name: 'followTimes',
          label: 'ติดตามครั้งที่ ',
          value: 0,
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณากรอกติดตามครั้งที่ ',
            },
          ],
        },
        projectSuccessInput: {
          name: 'projectSuccessInput',
          label: '% ความสำเร็จของโครงการ',
          value: 0,
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณากรอก % ความสำเร็จของโครงการ',
            },
          ],
        },
        summarizeInput: {
          name: 'summarizeInput',
          label: 'สรุปความเห็นผู้ติดตาม (การวิเคราะห์ภาพรวมผลการดำเนินงานโครงการและการใช้จ่ายเงิน)',
          value: 0,
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage:
                'กรุณากรอกสรุปความเห็นผู้ติดตาม (การวิเคราะห์ภาพรวมผลการดำเนินงานโครงการและการใช้จ่ายเงิน)',
            },
          ],
        },
        notesInput: {
          name: 'notesInput',
          label: 'ข้อสังเกต/สิ่งดีๆ ที่ค้นพบ/ บทเรียนที่ได้',
          value: 0,
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณากรอกข้อสังเกต/สิ่งดีๆ ที่ค้นพบ/ บทเรียนที่ได้',
            },
          ],
        },
        filesInput: {
          name: 'filesInput',
          header: 'แนบเอกสารหรือภาพประกอบ',
          hint: '',
          buttonText: 'ไฟล์ประกอบการติดตาม',
          fileSize: 50,
          fileType: '.jpg, .jpeg, .png, .pdf',
          description: ['แนบเอกสารหรือภาพประกอบ'],
          value: [
            {
              seqNo: 1,
              isUpSeqNo: true,
              isDownSeqNo: false,
              label: 'ไฟล์ทดสอบ.png',
              name: 'ไฟล์ทดสอบ.png',
              path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
              type: null,
              size: 0,
              id: '030CF477-509D-494A-8226-BF870998E63B',
            },
            {
              seqNo: 1,
              isUpSeqNo: true,
              isDownSeqNo: false,
              label: 'ไฟล์ทดสอบ.png',
              name: 'ไฟล์ทดสอบ.png',
              path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
              type: null,
              size: 0,
              id: '030CF477-509D-494A-8226-BF870998E63B',
            },
            {
              seqNo: 1,
              isUpSeqNo: true,
              isDownSeqNo: false,
              label: 'ไฟล์ทดสอบ.png',
              name: 'ไฟล์ทดสอบ.png',
              path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
              type: null,
              size: 0,
              id: '030CF477-509D-494A-8226-BF870998E63B',
            },
            {
              seqNo: 1,
              isUpSeqNo: true,
              isDownSeqNo: false,
              label: 'ไฟล์ทดสอบ.png',
              name: 'ไฟล์ทดสอบ.png',
              path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
              type: null,
              size: 0,
              id: '030CF477-509D-494A-8226-BF870998E63B',
            },
          ],
        },
      },
      performanceResults: {
        header: '1. ผลการดำเนินงาน',
        objective: {
          header: 'วัตถุประสงค์',
          input: {
            targetedResult: {
              name: 'targetedResult',
              label: 'ผลลัพธ์ที่ตั้งไว้',
              disable: true,
              value: '',
              hint: 'ผลลัพธ์ที่ตั้งไว้',
              validators: [
                { type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกผลลัพธ์ที่ตั้งไว้' },
              ],
            },
            actualResults: {
              name: 'actualResults',
              label: 'ผลลัพธ์ที่เกิดขึ้นจริง (หลังจากดำเนินกิจกรรม)',
              disable: false,
              value: '',
              hint: 'ผลลัพธ์ที่เกิดขึ้นจริง (หลังจากดำเนินกิจกรรม)',
              validators: [
                {
                  type: 'REQUIRED',
                  value: null,
                  errorMessage: 'กรุณากรอกผลลัพธ์ที่เกิดขึ้นจริง (หลังจากดำเนินกิจกรรม)',
                },
              ],
            },
            button: {
              disable: false,
              text: 'บันทึก',
            },
          },
          values: [
            {
              objective: {
                id: 'xxxxx-xxxxx-xxxx1',
                label:
                  'พัฒนาเครือข่าย Spiritual Influencer นักสื่อสารสุขภาวะทางปัญญา ขับเคลื่อนอย่างเป็นรูปธรรม ในหลากหลายวงการ หน่วยงาน องค์กร ชุมชน',
              },
              targetedResult: {
                id: 'xxxxx-xxxxxxx-xxxxx1',
                value: '',
              },
              actualResults: {
                id: 'xxxxx-xxxxxxx-xxxxx1',
                value: '',
              },
            },
            {
              objective: {
                id: 'xxxxx-xxxxx-xxxx2',
                label:
                  'เพื่อสร้างพื้นที่การเรียนรู้สุขภาวะทางปัญญาออนไลน์ และออฟไลน์ ให้เกิดการพัฒนาศักยภาพสู่การนำไปใช้ได้จริงอย่างยั่งยืน',
              },
              targetedResult: {
                id: 'xxxxx-xxxxxxx-xxxxx2',
                value: '',
              },
              actualResults: {
                id: 'xxxxx-xxxxxxx-xxxxx2',
                value: '',
              },
            },
            {
              objective: {
                id: 'xxxxx-xxxxx-xxxx3',
                label:
                  'เพื่อสื่อสารสร้างความตระหนักถึงความสำคัญ และเรียนรู้สุขภาวะทางปัญญา สู่สังคมในวงกว้าง',
              },
              targetedResult: {
                id: 'xxxxx-xxxxxxx-xxxxx3',
                value: '',
              },
              actualResults: {
                id: 'xxxxx-xxxxxxx-xxxxx3',
                value: '',
              },
            },
          ],
        },
        resultsOfOperations: {
          header: 'ผลการดำเนินการ (กิจกรรม)',
          activities: [
            {
              id: 'xxxxx-xxxxx-xxxx-xxx1',
              input: {
                name: 'activities',
                label: 'กิจกรรมที่ 1 Oneness Connect : Spiritual Influencer Network',
                disable: false,
                value:
                  '1เชิญชวนรวบรวม Influencer ที่เป็นนักสื่อสารสุขภาวะทางปัญญาและจิตวิญญาณ ทั้งที่เป็นนักสื่อสารเดิมที่โครงการ We Oneness สร้างเครือข่ายไว้แล้ว และนักสื่อสารรุ่นใหม่ มาร่วมเครือข่าย Spiritual Influencer นักสื่อสารสุขภาวะทางปัญญา ',
                hint: 'รายละเอียดกิจกรรม',
                validators: [
                  { type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกรายละเอียดกิจกรรม' },
                ],
              },
              activitiesDetail: [
                {
                  id: 'xxxx-xxxx-xxx-xxx',
                  name: 'activitiesResult',
                  label: 'ผลการดำเนินงาน',
                  disable: false,
                  value: '',
                  activityStartDateInput: {
                    label: 'วันที่เริ่มกิจกรรม',
                    name: 'activityStartDate',
                    disable: false,
                    value: '',
                    validators: [
                      {
                        type: 'REQUIRED',
                        value: null,
                        errorMessage: 'กรุณาระบุวันที่เริ่มกิจกรรม',
                      },
                    ],
                  },
                  activityEndDateInput: {
                    label: 'วันที่สิ้นสุดกิจกรรม',
                    name: 'activityEndDate',
                    disable: false,
                    value: '',
                    validators: [
                      {
                        type: 'REQUIRED',
                        value: null,
                        errorMessage: 'กรุณาระบุวันที่สิ้นสุดกิจกรรม',
                      },
                    ],
                  },
                  locationInput: {
                    label: 'สถานที่จัดกิจกรรม',
                    name: 'locationInput',
                    disable: false,
                    value: '',
                    validators: [
                      // {
                      //   type: 'REQUIRED',
                      //   value: null,
                      //   errorMessage: 'กรุณาระบุสถานที่จัดกิจกรรม',
                      // },
                    ],
                  },
                  targetGroupInput: {
                    label: 'กลุ่มเป้าหมาย',
                    name: 'targetGroupInput',
                    disable: false,
                    value: '',
                    validators: [
                      {
                        type: 'REQUIRED',
                        value: null,
                        errorMessage: 'กรุณาระบุกลุ่มเป้าหมาย',
                      },
                    ],
                  },
                },
                {
                  name: 'activitiesImage',
                  label: 'รูปภาพประกอบกิจกรรม',
                  disable: false,
                  attachFiles: {
                    name: 'attachFiles',
                    header: 'รูปภาพประกอบกิจกรรม',
                    hint: 'รูปภาพประกอบอย่างน้อย 4 รูป',
                    buttonText: 'ไฟล์ประกอบการติดตาม',
                    fileSize: 50,
                    fileType: '.jpg, .jpeg, .png',
                    description: ['รูปภาพประกอบกิจกรรม'],
                    value: [
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                    ],
                    id: null,
                  },
                  attachVideo: {
                    name: 'attachVideo',
                    label: 'Link VDO',
                    attachVideoName: {
                      name: 'attachVideoName',
                      label: 'ชื่อ Video',
                      value: '',
                      validators: [
                        // {
                        //   type: 'REQUIRED',
                        //   value: null,
                        //   errorMessage: 'กรุณากรอกชื่อ Video',
                        // },
                      ],
                    },
                    attachVideoLink: {
                      name: 'attachVideoLink',
                      label: 'Link VDO',
                      value: '',
                      validators: [
                        // {
                        //   type: 'REQUIRED',
                        //   value: null,
                        //   errorMessage: 'กรุณากรอกLink VDO',
                        // },
                      ],
                    },
                    button: {
                      text: 'เพิ่ม',
                    },
                    value: [
                      {
                        seqNo: 1,
                        name: 'ไฟล์ทดสอบ.png',
                        link: 'https://www.youtube.com/watch?v=giKzn07ZrfA',
                      },
                    ],
                  },
                  attachFilesEtc: {
                    name: 'attachFilesEtc',
                    header: 'แนบไฟล์อื่นๆ',
                    hint: 'แนบไฟล์อื่นๆ',
                    buttonText: 'ไฟล์ประกอบการติดตาม',
                    fileSize: 50,
                    fileType: '.jpg, .jpeg, .png',
                    description: ['รูปภาพประกอบกิจกรรม'],
                    value: [
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                    ],
                    id: null,
                  },
                  button: {
                    text: 'บันทึก',
                  },
                },
                {
                  name: 'activitiesBudget',
                  label: 'งบประมาณกิจกรรม',
                  disable: false,
                  noExpenditureOccurredOption: {
                    name: 'noExpenditureOccurredOption',
                    label: 'ไม่มีรายการใช้จ่ายเกิดขึ้น',
                    value: 0,
                    options: [
                      { disabled: false, label: 'ไม่มีรายการใช้จ่ายเกิดขึ้น', value: 0 },
                      // { disabled: false, label: 'มี', value: 1 },
                    ],
                  },
                  income: {
                    name: 'income',
                    title: 'รายรับ',
                    unitText: 'บาท',
                    budgetInput: {
                      name: 'budgetInput',
                      label: 'งบที่ได้รับ',
                      disable: false,
                      value: '1000000.00',
                      hint: 'ระบุงบที่ได้รับ',
                      validators: [
                        // {
                        //   type: 'REQUIRED',
                        //   value: null,
                        //   errorMessage: 'กรุณากรอกงบที่ได้รับ',
                        // },
                      ],
                    },
                  },
                  expenses: {
                    title: 'รายจ่าย',
                    compensationInput: {
                      name: 'compensationInput',
                      buttonInfo: 'ค่าตอบแทนอาสาสมัคร ค่าตอบแทนวิทยากร ค่าตอบแทนประสานงาน',
                      label: 'ค่าตอบแทน',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าตอบแทน',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าตอบแทน',
                        },
                      ],
                    },
                    wagesInput: {
                      name: 'wagesInput',
                      buttonInfo: 'ค่าจ้างจัดทำข้อมูล ค่าจ้างทำของ',
                      label: 'ค่าจ้าง',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าจ้าง',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าจ้าง',
                        },
                      ],
                    },
                    expensesInput: {
                      name: 'expensesInput',
                      buttonInfo:
                        'ค่าใช้จ่ายเพื่อซื้อบริการต่างๆ อาทิ ค่าพาหนะ ค่าที่พัก ค่าถ่ายเอกสาร ค่าเช่าห้องประชุม ค่าอาหารและเครื่องดื่ม ค่าเช่าสถานที่',
                      label: 'ค่าใช้สอย',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าใช้สอย',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าใช้สอย',
                        },
                      ],
                    },
                    materialCostInput: {
                      name: 'materialCostInput',
                      buttonInfo:
                        'ค่าใช้จ่ายเพื่อซื้อวัสดุสิ้นเปลืองในสำนักงานหรือใช้ในการทำกิจกรรม เช่น วัสดุเครื่องเขียนวัสดุสำนักงาน วัสดุโฆษณาและเผยแพร่',
                      label: 'ค่าวัสดุ',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าวัสดุ',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าวัสดุ',
                        },
                      ],
                    },
                    utilityCostsInput: {
                      name: 'utilityCostsInput',
                      buttonInfo: 'ค่าไฟฟ้า ค่าน้ำประปา ค่าโทรศัพท์ ค่าไปรษณีย์ภัณฑ์',
                      label: 'ค่าสาธารณูปโภค',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าสาธารณูปโภค',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าสาธารณูปโภค',
                        },
                      ],
                    },
                    otherValuesInput: {
                      name: 'otherValuesInput',
                      // buttonInfo: 'xxxxx',
                      label: 'ค่าอื่นๆ',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าอื่นๆ',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าอื่นๆ',
                        },
                      ],
                    },
                    totalExpensesInput: {
                      name: 'totalExpensesInput',
                      // buttonInfo: 'xxxxx',
                      label: 'รวมรายจ่าย',
                      disable: false,
                      value: '-200.00',
                      hint: 'ระบุรวมรายจ่าย',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกรวมรายจ่าย',
                        },
                      ],
                    },
                    unitText: 'บาท',
                  },
                  attachFiles: {
                    name: 'attachFiles',
                    header: 'แนบใบเสร็จรับเงิน',
                    // hint: 'รูปภาพประกอบอย่างน้อย 4 รูป',
                    buttonText: 'ไฟล์ประกอบการติดตาม',
                    fileSize: 50,
                    fileType: '.jpg, .jpeg, .png',
                    description: ['แนบใบเสร็จรับเงิน'],
                    validators: [
                      // {
                      //   type: 'REQUIRED',
                      //   value: null,
                      //   errorMessage: 'กรุณากรอกแนบใบเสร็จรับเงิน',
                      // },
                    ],
                    value: [
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                    ],
                    id: null,
                  },
                },
              ],
            },
            {
              id: 'xxxxx-xxxxx-xxxx-xxx2',
              input: {
                name: 'activities',
                label: 'กิจกรรมที่ 2 Oneness Connect : Spiritual Influencer Network',
                disable: false,
                value:
                  '2เชิญชวนรวบรวม Influencer ที่เป็นนักสื่อสารสุขภาวะทางปัญญาและจิตวิญญาณ ทั้งที่เป็นนักสื่อสารเดิมที่โครงการ We Oneness สร้างเครือข่ายไว้แล้ว และนักสื่อสารรุ่นใหม่ มาร่วมเครือข่าย Spiritual Influencer นักสื่อสารสุขภาวะทางปัญญา ',
                hint: 'รายละเอียดกิจกรรม',
                validators: [
                  { type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกรายละเอียดกิจกรรม' },
                ],
              },
              activitiesDetail: [
                {
                  id: 'xxxx-xxxx-xxx-xxx',
                  name: 'activitiesResult',
                  label: 'ผลการดำเนินงาน',
                  disable: false,
                  value: '',
                  activityStartDateInput: {
                    label: 'วันที่เริ่มกิจกรรม',
                    name: 'activityStartDate',
                    disable: false,
                    value: '',
                    validators: [
                      {
                        type: 'REQUIRED',
                        value: null,
                        errorMessage: 'กรุณาระบุวันที่เริ่มกิจกรรม',
                      },
                    ],
                  },
                  activityEndDateInput: {
                    label: 'วันที่สิ้นสุดกิจกรรม',
                    name: 'activityEndDate',
                    disable: false,
                    value: '',
                    validators: [
                      {
                        type: 'REQUIRED',
                        value: null,
                        errorMessage: 'กรุณาระบุวันที่สิ้นสุดกิจกรรม',
                      },
                    ],
                  },
                  locationInput: {
                    label: 'สถานที่จัดกิจกรรม',
                    name: 'locationInput',
                    disable: false,
                    value: '',
                    validators: [
                      // {
                      //   type: 'REQUIRED',
                      //   value: null,
                      //   errorMessage: 'กรุณาระบุสถานที่จัดกิจกรรม',
                      // },
                    ],
                  },
                  targetGroupInput: {
                    label: 'กลุ่มเป้าหมาย',
                    name: 'targetGroupInput',
                    disable: false,
                    value: '',
                    validators: [
                      {
                        type: 'REQUIRED',
                        value: null,
                        errorMessage: 'กรุณาระบุกลุ่มเป้าหมาย',
                      },
                    ],
                  },
                },
                {
                  name: 'activitiesImage',
                  label: 'รูปภาพประกอบกิจกรรม',
                  disable: false,
                  attachFiles: {
                    name: 'attachFiles',
                    header: 'รูปภาพประกอบกิจกรรม',
                    hint: 'รูปภาพประกอบอย่างน้อย 4 รูป',
                    buttonText: 'ไฟล์ประกอบการติดตาม',
                    fileSize: 50,
                    fileType: '.jpg, .jpeg, .png',
                    description: ['รูปภาพประกอบกิจกรรม'],
                    value: [
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                    ],
                    id: null,
                  },
                  attachVideo: {
                    name: 'attachVideo',
                    label: 'Link VDO',
                    attachVideoName: {
                      name: 'attachVideoName',
                      label: 'ชื่อ Video',
                      value: '',
                      validators: [
                        // {
                        //   type: 'REQUIRED',
                        //   value: null,
                        //   errorMessage: 'กรุณากรอกชื่อ Video',
                        // },
                      ],
                    },
                    attachVideoLink: {
                      name: 'attachVideoLink',
                      label: 'Link VDO',
                      value: '',
                      validators: [
                        // {
                        //   type: 'REQUIRED',
                        //   value: null,
                        //   errorMessage: 'กรุณากรอกLink VDO',
                        // },
                      ],
                    },
                    button: {
                      text: 'เพิ่ม',
                    },
                    value: [
                      {
                        seqNo: 1,
                        name: 'ไฟล์ทดสอบ.png',
                        link: 'https://www.youtube.com/watch?v=giKzn07ZrfA',
                      },
                    ],
                  },
                  attachFilesEtc: {
                    name: 'attachFilesEtc',
                    header: 'แนบไฟล์อื่นๆ',
                    hint: 'แนบไฟล์อื่นๆ',
                    buttonText: 'ไฟล์ประกอบการติดตาม',
                    fileSize: 50,
                    fileType: '.jpg, .jpeg, .png',
                    description: ['รูปภาพประกอบกิจกรรม'],
                    value: [
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                    ],
                    id: null,
                  },
                  button: {
                    text: 'บันทึก',
                  },
                },
                {
                  name: 'activitiesBudget',
                  label: 'งบประมาณกิจกรรม',
                  disable: false,
                  noExpenditureOccurredOption: {
                    name: 'noExpenditureOccurredOption',
                    label: 'ไม่มีรายการใช้จ่ายเกิดขึ้น',
                    value: 0,
                    options: [
                      { disabled: false, label: 'ไม่มีรายการใช้จ่ายเกิดขึ้น', value: 0 },
                      // { disabled: false, label: 'มี', value: 1 },
                    ],
                  },
                  income: {
                    name: 'income',
                    title: 'รายรับ',
                    unitText: 'บาท',
                    budgetInput: {
                      name: 'budgetInput',
                      label: 'งบที่ได้รับ',
                      disable: false,
                      value: '1000000.00',
                      hint: 'ระบุงบที่ได้รับ',
                      validators: [
                        // {
                        //   type: 'REQUIRED',
                        //   value: null,
                        //   errorMessage: 'กรุณากรอกงบที่ได้รับ',
                        // },
                      ],
                    },
                  },
                  expenses: {
                    title: 'รายจ่าย',
                    compensationInput: {
                      name: 'compensationInput',
                      buttonInfo: 'ค่าตอบแทนอาสาสมัคร ค่าตอบแทนวิทยากร ค่าตอบแทนประสานงาน',
                      label: 'ค่าตอบแทน',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าตอบแทน',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าตอบแทน',
                        },
                      ],
                    },
                    wagesInput: {
                      name: 'wagesInput',
                      buttonInfo: 'ค่าจ้างจัดทำข้อมูล ค่าจ้างทำของ',
                      label: 'ค่าจ้าง',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าจ้าง',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าจ้าง',
                        },
                      ],
                    },
                    expensesInput: {
                      name: 'expensesInput',
                      buttonInfo:
                        'ค่าใช้จ่ายเพื่อซื้อบริการต่างๆ อาทิ ค่าพาหนะ ค่าที่พัก ค่าถ่ายเอกสาร ค่าเช่าห้องประชุม ค่าอาหารและเครื่องดื่ม ค่าเช่าสถานที่',
                      label: 'ค่าใช้สอย',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าใช้สอย',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าใช้สอย',
                        },
                      ],
                    },
                    materialCostInput: {
                      name: 'materialCostInput',
                      buttonInfo:
                        'ค่าใช้จ่ายเพื่อซื้อวัสดุสิ้นเปลืองในสำนักงานหรือใช้ในการทำกิจกรรม เช่น วัสดุเครื่องเขียนวัสดุสำนักงาน วัสดุโฆษณาและเผยแพร่',
                      label: 'ค่าวัสดุ',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าวัสดุ',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าวัสดุ',
                        },
                      ],
                    },
                    utilityCostsInput: {
                      name: 'utilityCostsInput',
                      buttonInfo: 'ค่าไฟฟ้า ค่าน้ำประปา ค่าโทรศัพท์ ค่าไปรษณีย์ภัณฑ์',
                      label: 'ค่าสาธารณูปโภค',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าสาธารณูปโภค',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าสาธารณูปโภค',
                        },
                      ],
                    },
                    otherValuesInput: {
                      name: 'otherValuesInput',
                      // buttonInfo: 'xxxxx',
                      label: 'ค่าอื่นๆ',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าอื่นๆ',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าอื่นๆ',
                        },
                      ],
                    },
                    totalExpensesInput: {
                      name: 'totalExpensesInput',
                      // buttonInfo: 'xxxxx',
                      label: 'รวมรายจ่าย',
                      disable: false,
                      value: '-200.00',
                      hint: 'ระบุรวมรายจ่าย',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกรวมรายจ่าย',
                        },
                      ],
                    },
                    unitText: 'บาท',
                  },
                  attachFiles: {
                    name: 'attachFiles',
                    header: 'แนบใบเสร็จรับเงิน',
                    // hint: 'รูปภาพประกอบอย่างน้อย 4 รูป',
                    buttonText: 'ไฟล์ประกอบการติดตาม',
                    fileSize: 50,
                    fileType: '.jpg, .jpeg, .png',
                    description: ['แนบใบเสร็จรับเงิน'],
                    validators: [
                      // {
                      //   type: 'REQUIRED',
                      //   value: null,
                      //   errorMessage: 'กรุณากรอกแนบใบเสร็จรับเงิน',
                      // },
                    ],
                    value: [
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                    ],
                    id: null,
                  },
                },
              ],
            },
          ],
        },
      },
      progress: {
        header: '2. ความก้าวหน้า',
        subtitle:
          'ประเมินความก้าวหน้าของการดำเนินงานโครงการและปัญหาอุปสรรคสำคัญที่มีผลต่อการดำเนินงาน',
        sliderInput: {
          name: 'sliderInput',
          label: 'ประเมินความก้าวหน้าของการดำเนินโครงการ',
          disable: false,
          defaultValue: 50,
          min: 0,
          step: 10,
          max: 100,
          hint: 'รายละเอียดกิจกรรม',
        },
        affectingOperations: {
          title: 'ปัญหาอุปสรรคสำคัญที่มีผลต่อการดำเนินงาน',
          issueInput: {
            name: 'issueInput',
            label: 'ประเด็นปัญหา / อุปสรรค',
            value: '',
            validators: [
              {
                type: 'REQUIRED',
                value: null,
                errorMessage: 'กรุณากรอกประเด็นปัญหา / อุปสรรค',
              },
            ],
          },
          reasonInput: {
            name: 'reasonInput',
            label: 'สาเหตุเพราะ',
            value: '',
            validators: [
              {
                type: 'REQUIRED',
                value: null,
                errorMessage: 'กรุณากรอกสาเหตุเพราะ',
              },
            ],
          },
          solutionsInput: {
            name: 'solutionsInput',
            label: ' แนวทางการแก้ไขของผู้รับทุน',
            value: '',
            validators: [
              {
                type: 'REQUIRED',
                value: null,
                errorMessage: 'กรุณากรอกแนวทางการแก้ไขของผู้รับทุน',
              },
            ],
          },
          values: [
            {
              id: '',
              issue: '',
              reason: '',
              solutions: '',
            },
          ],
        },
      },
      otherOutcomes: {
        header: '3.ผลลัพธ์อื่นๆ',
        subTitle: 'ผลลัพธ์ของโครงการที่สอดคล้องเป้าหมายตัวชี้วัดของแผน',
        fullNameInput: {
          name: 'fullNameInput',
          label: 'ชื่อ - สกุลของแกนนำ',
          value: '',
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณากรอกชื่อ - สกุลของแกนนำ',
            },
          ],
        },
        roleInput: {
          name: 'roleInput',
          label: 'บทบาทหน้าที่',
          value: '',
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณากรอกบทบาทหน้าที่',
            },
          ],
        },
        telephoneInput: {
          name: 'telephoneInput',
          label: 'เบอร์โทรศัพท์',
          value: '',
          validators: [
            // {
            //   type: 'REQUIRED',
            //   value: null,
            //   errorMessage: 'กรุณากรอกเบอร์โทรศัพท์',
            // },
          ],
        },
        email: {
          name: 'email',
          label: 'อีเมล',
          value: '',
          validators: [
            // {
            //   type: 'REQUIRED',
            //   value: null,
            //   errorMessage: 'กรุณากรอกอีเมล',
            // },
          ],
        },
        values: [
          {
            id: '1',
            title: 'แกนนำในด้านการสร้างเสริมสุขภาพในประเด็นต่างๆ',
            name: '',
            role: '',
            province: '',
            address: '',
            telephone: '',
            idCard: '',
          },
        ],
        healthInnovation: {
          title: '3.1 นวัตกรรมสร้างเสริมสุขภาพ',
          healthInnovationName: {
            name: 'healthInnovationName',
            label: 'ชื่อนวัตกรรม',
            value: '',
            validators: [
              // {
              //   type: 'REQUIRED',
              //   value: null,
              //   errorMessage: 'กรุณากรอกชื่อนวัตกรรม',
              // },
            ],
          },
          healthInnovationNature: {
            name: 'healthInnovationNature',
            label: 'ลักษณะนวัตกรรม',
            value: '',
            options: [
              { disabled: false, label: 'การพัฒนาความรู้ใหม่จากการวิจัย', value: 0 },
              {
                disabled: false,
                label: 'การนำสิ่งที่มีอยู่ในชุมชนอื่นมาปรับใช้ในชุมชนตนเอง',
                value: 1,
              },
              {
                disabled: false,
                label: 'การนำสิ่งที่มีอยู่มาปรับกระบวนทัศน์ใหม่หรือทำด้วยวิธีใหม่',
                value: 2,
              },
              {
                disabled: false,
                label: 'การรื้อฟื้นสิ่งดีๆ ที่เตยมีในชุมชนมาปรับให้สอดคล้องกับสถานการณ์ปัจจุบัน',
                value: 3,
              },
            ],
            validators: [
              // {
              //   type: 'REQUIRED',
              //   value: null,
              //   errorMessage: 'กรุณากรอกลักษณะนวัตกรรม',
              // },
            ],
          },
          healthInnovationDetail: {
            name: 'healthInnovationDetail',
            label: 'รายละเอียดนวัตกรรม',
            value: '',
            validators: [
              // {
              //   type: 'REQUIRED',
              //   value: null,
              //   errorMessage: 'กรุณากรอกรายละเอียดนวัตกรรม',
              // },
            ],
          },
          healthInnovationUtilization: {
            name: 'healthInnovationUtilization',
            label: 'การนำนวัตกรรมไปใช้ประโยชน์',
            value: '',
            validators: [
              // {
              //   type: 'REQUIRED',
              //   value: null,
              //   errorMessage: 'กรุณากรอกการนำนวัตกรรมไปใช้ประโยชน์',
              // },
            ],
          },
          healthInnovationFiles: {
            name: 'healthInnovationFiles',
            label: 'แนบไฟล์เอกสารประกอบเพิ่ม',
            value: [
              {
                seqNo: 1,
                isUpSeqNo: true,
                isDownSeqNo: false,
                label: 'ไฟล์ทดสอบ.png',
                name: 'ไฟล์ทดสอบ.png',
                path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                type: null,
                size: 0,
                id: '030CF477-509D-494A-8226-BF870998E63B',
              },
            ],
            validators: [
              // {
              //   type: 'REQUIRED',
              //   value: null,
              //   errorMessage: 'กรุณากรอกแนบไฟล์เอกสารประกอบเพิ่ม',
              // },
            ],
          },
          values: [
            {
              healthInnovationName: '',
              healthInnovationNature: '',
              healthInnovationDetail: '',
              healthInnovationUtilization: '',
              healthInnovationFiles: [
                {
                  seqNo: 1,
                  isUpSeqNo: true,
                  isDownSeqNo: false,
                  label: 'ไฟล์ทดสอบ.png',
                  name: 'ไฟล์ทดสอบ.png',
                  path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                  type: null,
                  size: 0,
                  id: '030CF477-509D-494A-8226-BF870998E63B',
                },
              ],
            },
          ],
        },
        bestPractice: null,
      },
      data: {
        totalSize: 6,
        values: [
          {
            id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
            dateFollow: '01/02/2024',
            followTimes: '1',
            projectSuccessInput: '10%',
            summarizeInput: 'เจ้าหน้าที่โครงการทำกิจกรรมได้ตามเป้าหมาย',
            notesInput: 'ทำดีมาก',
            totalSize: 3,
          },
          {
            id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
            dateFollow: '15/04/2024',
            followTimes: '2',
            projectSuccessInput: '47%',
            summarizeInput: 'ขาดการประสานงานทำให้อาจส่งงานล่าช้าได้',
            notesInput: 'ไม่มีพบประสานงานในพื้นที่',
            totalSize: 3,
          },
          {
            id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
            dateFollow: '01/02/2024',
            followTimes: '3',
            projectSuccessInput: '69%',
            summarizeInput: 'โครงการมีโอกาสล่าช้าจากการติดตามผล',
            notesInput: '-',
            totalSize: 3,
          },
        ],
      },
    },
    header: 'ค้นหาข้อมูลโครงการย่อย',
    subHeader: null,
    disabled: true,
    isApprover: false,
    isReadOnly: true,
  },
}
